var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4870_5593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20.7143V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4870_5593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7847 3.64656H18.1252C18.7234 3.64656 19.2972 3.88421 19.7202 4.30722C20.1432 4.73024 20.3808 5.30397 20.3808 5.9022V17.1804C20.3808 17.7786 20.1432 18.3524 19.7202 18.7754C19.2972 19.1984 18.7234 19.436 18.1252 19.436H2.33572C1.73748 19.436 1.16375 19.1984 0.74074 18.7754C0.317725 18.3524 0.0800781 17.7786 0.0800781 17.1804V5.9022C0.0800781 5.30397 0.317725 4.73024 0.74074 4.30722C1.16375 3.88421 1.73748 3.64656 2.33572 3.64656H4.67362V1.74588C4.67362 0.869234 5.38428 0.158575 6.26092 0.158575H14.1974C15.0741 0.158575 15.7847 0.869234 15.7847 1.74588V3.64656ZM6.67362 3.64656H13.7847V2.15858H6.67362V3.64656Z",
    fill: "#171717"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7661 10.2765H11.4987V9.00908C11.4987 8.67295 11.3652 8.35059 11.1275 8.11291C10.8898 7.87523 10.5675 7.7417 10.2313 7.7417C9.89521 7.7417 9.57285 7.87523 9.33517 8.11291C9.09749 8.35059 8.96396 8.67295 8.96396 9.00908V10.2765H7.69658C7.36045 10.2765 7.03809 10.41 6.80041 10.6477C6.56273 10.8853 6.4292 11.2077 6.4292 11.5438C6.4292 11.88 6.56273 12.2023 6.80041 12.44C7.03809 12.6777 7.36045 12.8112 7.69658 12.8112H8.96396V14.0786C8.96396 14.4147 9.09749 14.7371 9.33517 14.9748C9.57285 15.2125 9.89521 15.346 10.2313 15.346C10.5675 15.346 10.8898 15.2125 11.1275 14.9748C11.3652 14.7371 11.4987 14.4147 11.4987 14.0786V12.8112H12.7661C13.1022 12.8112 13.4246 12.6777 13.6623 12.44C13.9 12.2023 14.0335 11.88 14.0335 11.5438C14.0335 11.2077 13.9 10.8853 13.6623 10.6477C13.4246 10.41 13.1022 10.2765 12.7661 10.2765Z",
    fill: "white",
    stroke: "#171717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.8986105bd29c651ead53a43708e01797.svg";
export { ForwardRef as ReactComponent };